import {NgModule} from "@angular/core";
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatRadioModule} from "@angular/material/radio";
import {MatDividerModule} from "@angular/material/divider";
import {MatIconModule} from "@angular/material/icon";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatCardModule} from "@angular/material/card";
import {MatStepperModule} from "@angular/material/stepper";
import {MatInputModule} from "@angular/material/input";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatMenuModule} from "@angular/material/menu";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatListModule} from "@angular/material/list";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatSelectModule} from "@angular/material/select";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatChipsModule} from "@angular/material/chips";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatTabsModule} from '@angular/material/tabs';
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatTableModule} from "@angular/material/table";
import {MatSortModule} from "@angular/material/sort";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatRippleModule} from "@angular/material/core";
import {MatBadgeModule} from "@angular/material/badge";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatExpansionModule} from '@angular/material/expansion';
import {NgbCollapseModule} from "@ng-bootstrap/ng-bootstrap";

@NgModule({
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    MatRadioModule,
    MatDividerModule,
    MatIconModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatCardModule,
    MatStepperModule,
    MatInputModule,
    MatProgressBarModule,
    MatMenuModule,
    MatSnackBarModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatDatepickerModule,
    MatChipsModule,
    MatToolbarModule,
    MatTabsModule,
    MatTabsModule,
    MatSidenavModule,
    MatToolbarModule,
    MatInputModule,
    MatExpansionModule,
    MatTableModule,
    MatSortModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatRippleModule,
    MatBadgeModule,
    MatListModule,
    MatButtonToggleModule,
    NgbCollapseModule
  ],
  exports: [
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    MatRadioModule,
    MatDividerModule,
    MatIconModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatCardModule,
    MatStepperModule,
    MatInputModule,
    MatProgressBarModule,
    MatMenuModule,
    MatSnackBarModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatDatepickerModule,
    MatChipsModule,
    MatToolbarModule,
    MatTabsModule,
    MatSidenavModule,
    MatToolbarModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatRippleModule,
    MatBadgeModule,
    MatButtonToggleModule,
    MatExpansionModule,
    NgbCollapseModule
  ]
})
export class MaterialModule {
}
